import { render, staticRenderFns } from "./dataAuthorization.vue?vue&type=template&id=ca5db826&scoped=true&"
import script from "./dataAuthorization.vue?vue&type=script&lang=js&"
export * from "./dataAuthorization.vue?vue&type=script&lang=js&"
import style0 from "./dataAuthorization.vue?vue&type=style&index=0&id=ca5db826&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca5db826",
  null
  
)

export default component.exports